var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SftpStatus'),_c('Providers',{attrs:{"providers":_vm.entity.providers,"show-latest-cad-data-link":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }